import React , {Component} from 'react';
import Footer from "./div/Footer";
import {Link} from "react-router-dom";
import arrowLeftIcon from './../assets/images/icons/arrow-left-2.svg';
import shoppingBagIcon from './../assets/images/icons/shopping-bag-2.svg';
import mapIcon from './../assets/images/icons/map.svg';
import editIcon from './../assets/images/icons/edit.svg';
import faceIcon from './../assets/images/icons/face.svg';
import face2Icon from './../assets/images/icons/face-2.svg';
import userIcon from './../assets/images/icons/user.svg';
import user2Icon from './../assets/images/icons/user-2.svg';
import smartPhone2Icon from './../assets/images/icons/smartphone2.svg';
import chatIcon from './../assets/images/icons/chat.svg';
import chat2Icon from './../assets/images/icons/chat-2.svg';
import bellIcon from './../assets/images/icons/bell.svg';
import NumberFormat from 'react-number-format';
import { Swiper , Thumbs , History , HashNavigation } from 'swiper';

import * as axios from "axios/index";
import * as vars from './Vars';
import validator from "validator";
import { Modal } from 'react-bootstrap';

Swiper.use([Thumbs , History , HashNavigation ]);

class Profile extends Component{
    constructor(props){

        super(props)
        this.state = {

            unreadArticle : false ,
            inPageLoading : false ,
            errors : {} ,
            fields : {
                name : localStorage.getItem("name") ,
                gender : localStorage.getItem("gender") ,
                body : "" ,
                price : 0 ,
            } ,
            messageError : null ,
            messageModal : false ,

            userModal : false ,
            walletModal : false ,
            userError : null ,
        }
    }
    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
    }

    walletModalShowHandler()
    {

        this.setState({
            walletModal : true ,
        })

        setTimeout(
            function() {

                let priceSlier = new Swiper('#price-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 10,

                })
                priceSlier.update()
            }
            .bind(this),
            100
        )
    }
    walletModalHideHandler()
    {
        this.setState({
            walletModal : false ,
            messageError : null ,
        })
    }
    walletModalSubmitHandler()
    {
        let { fields } = this.state
        let errors = {}
        let formValid = true

        if ( fields.price === 0 )
        {
            formValid = false;
            errors['body'] = 'مبلغ مورد نظر خود را وارد کنید';
        }

        if (formValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }


        this.setState({
            inPageLoading : true
        })

        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        data.append('price' , this.state.fields.price )

        axios.post(vars.Url +'api/v1/wallet/store' , data , {
            params : {
            }

        } )
            .then((response) => {
                let data = response.data.data
                /*this.setState({
                    inPageLoading : false ,
                    messageModal : false ,
                })*/
                window.location.replace(data.targetUrl)
            })
            .catch( (error) => {
                let data = error.response.data.data
                this.setState({
                    inPageLoading : false ,
                    messageError : data.message ,
                })
            })
    }

    messageModalHideHandler(){
        this.setState({
            messageModal : false ,
            messageError : null ,
        })
    }

    messageModalSubmitHandler(){
        let { fields } = this.state
        let errors = {}
        let formValid = true

        if ( fields.body === null || validator.isEmpty(fields.body))
        {
            formValid = false;
            errors['body'] = 'متن پیام خود را وارد کنید';
        }
        else if(! validator.isLength(fields.body , { min : 5}))
        {
            formValid = false;
            errors['body'] = 'متن پیام باید 5 حرف باشد';
        }

        if (formValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }


        this.setState({
            inPageLoading : true
        })

        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        data.append('body' , this.state.fields.body )

        axios.post(vars.Url +'api/v1/message/store' , data , {
            params : {
            }

        } )
            .then((response) => {
                let data = response.data.data
                // console.log(data)


                this.setState({
                    inPageLoading : false ,
                    messageModal : false ,
                    fields : {
                        name : this.state.fields.name ,
                        gender : this.state.fields.gender ,
                        body : "" ,
                    } ,
                })
            })
            .catch( (error) => {
                let data = error.response.data.data
                this.setState({
                    inPageLoading : false ,
                    messageError : data.message ,
                })
            })


    }

    userModalHideHandler()
    {

        this.setState({
            userModal : false,
            messageError : null ,
        })
    }

    userSubmitHandler(){


        let { fields } = this.state
        let errors = {}
        let formValid = true

        if ( fields.name === null || validator.isEmpty(fields.name))
        {
            formValid = false;
            errors['name'] = 'نام خود را وارد کنید';
        }


        if (formValid === false)
        {
            this.setState({
                errors : errors
            })
            return false
        }

        this.setState({
            inPageLoading : true
        })
        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        data.append('name' , this.state.fields.name )
        data.append('gender' , this.state.fields.gender )
        axios.post(vars.Url +'api/v1/user/update' , data , {
            params : {
            }

        } )
        .then(response => {
            this.setState({
                inPageLoading : false ,
                userModal : false ,

            })

            let data = response.data.data

            localStorage.setItem("api_token" , data.user.api_token)
            localStorage.setItem("gender" , data.user.gender)
            localStorage.setItem("name" , data.user.name)
            localStorage.setItem("phone" , data.user.phone)
            localStorage.setItem("unreadMessage" , data.user.unreadMessage)
            localStorage.setItem("wallet" , data.user.wallet)

        })
        .catch(error => {
            let data = error.response.data.data
            // console.log(data)
            this.setState({
                inPageLoading : false ,
                userError : "اطلاعات خواسته شده را وارد کنید!" ,
            })
        })

    }

    render(){


        const {errors} = this.state
        const wallet = localStorage.getItem("wallet")
        const price = this.state.fields.price
        return(

            <div id="main-custom-1" className="text-decoration-none">

                <div id="in-page-loading" className={(this.state.inPageLoading === true ? "show" : "")}>
                    <div className="content-container">
                        <div className="text-center mb-3">
                            <i className="fas fa-circle-notch fa-spin item-icon" />
                        </div>
                        <div className="title">
                            لطفا شکیبا باشید
                        </div>
                    </div>
                </div>

                {/*<header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <span className="title">
                                                پروفایل
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>*/}



                <header id="header-5" className="text-decoration-none">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">

                                <div className="items-container">

                                    <div className="top-items">
                                        <div className="row justify-content-between">

                                            <div className="col-auto">
                                            </div>

                                            <div className="col-auto">
                                                <div  className={"bell-container " + (this.state.unreadArticle===true ? " active" : "")}>
                                                    <Link to="/article">
                                                        <div>
                                                            <img src={bellIcon} alt="bell" className="item-icon" />
                                                        </div>
                                                    </Link>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="bottom-items mt-5">
                                        <div className="row no-gutters justify-content-between align-items-end">
                                            <div className="col-auto">
                                                <div className="title">
                                                    اعتبار
                                                </div>
                                                <div className="sub-title">
                                                    <span className="value">
                                                        <NumberFormat value={wallet} displayType={'text'} thousandSeparator={true}  />
                                                    </span>
                                                    تومان

                                                    <button className="btn btn-custom-8 mr-3" onClick={this.walletModalShowHandler.bind(this) }>
                                                        <i className="fas fa-plus btn-item-icon" />
                                                        <span className="btn-title">
                                                            شارژ اعتبار
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>



                            </div>
                        </div>
                    </div>
                </header>





                <div className="container p-0 mt-5">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">
                            <div className="items-container items-container-custom-1">

                                <Link to="/order" className="details-custom-2 pt-4 pb-4 d-block">
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={shoppingBagIcon} alt="shopping bag"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="sub-title">
                                                        خریدهای من
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <img src={arrowLeftIcon} alt="call" className="ml-2"/>
                                        </div>
                                    </div>
                                </Link>

                                <Link to="/addresses" className="details-custom-2 pt-4 pb-4 d-block">
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={mapIcon} alt="map"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="sub-title">
                                                        آدرس‌های من
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <img src={arrowLeftIcon} alt="call" className="ml-2"/>
                                        </div>
                                    </div>
                                </Link>


                                <div className="divider-custom-1 " />

                                <div className="details-custom-2 pt-4 pb-4 d-block" onClick={() => this.setState({userModal:true})}>
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={face2Icon} alt="face"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="title">
                                                        نام و نام خانوادگی
                                                    </div>
                                                    <div className="sub-title">
                                                        {this.state.fields.name}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <img src={editIcon} alt="call" className="ml-2"/>
                                        </div>
                                    </div>
                                </div>



                                <div className="details-custom-2 pt-4 pb-4 d-block" onClick={() => this.setState({userModal:true})}>
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={user2Icon} alt="user"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="title">
                                                        جنسیت
                                                    </div>
                                                    <div className="sub-title">
                                                        {
                                                            this.state.fields.gender === "male" ?
                                                            (`مرد`)
                                                            :
                                                            (`زن`)
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <img src={editIcon} alt="call" className="ml-2"/>
                                        </div>
                                    </div>
                                </div>




                                <div className="details-custom-2 pt-4 pb-4 d-block" >
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={smartPhone2Icon} alt="smart Phone "/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="title">
                                                        تلفن همراه
                                                    </div>
                                                    <div className="sub-title">
                                                        { localStorage.getItem("phone") }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="divider-custom-1 " />



                                <div className="details-custom-2 pt-4 pb-4  d-block" onClick={() => this.setState({messageModal : true})}>
                                    <div className="row no-gutters justify-content-between align-items-center">
                                        <div className="col-auto">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-3">
                                                    <img src={chatIcon} alt="chat"/>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="sub-title">
                                                        ارسال پیام
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <img src={arrowLeftIcon} alt="arrow-left" />
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>



                <Modal
                    show={this.state.messageModal}
                    onHide={this.messageModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            ارسال پیام
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                خوشحال می شویم تا نظر، پیشنهاد و انتقادتان از بانان را برایمان بفرستید تا بتوانیم کیفیت خدماتمان را با نظراتتان ارتقاء دهیم.
                                <br />
                            </div>
                        </div>
                        <div>
                            {
                                this.state.messageError !== null ?
                                    (
                                        <div className="alert alert-danger mt-2">
                                            {this.state.messageError}
                                        </div>
                                    )
                                    :
                                    (``)
                            }
                        </div>
                        <div  className="mt-3">
                            <div className="form-group form-group-custom-1">
                               <textarea
                                   placeholder="پیام شما"
                                   name="body"
                                   className={["form-control form-control-custom-1" , errors['body'] ? 'is-invalid' : ''].join(' ')}
                                   onChange={this.handleChange.bind(this)}
                                   value={this.state.fields.body}
                                   rows={3}
                               />
                                <span className={["invalid-feedback" ,  errors['discount_code'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['discount_code'] }</span>

                                <img src={chat2Icon} alt="chat" className="item-icon" />
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.messageModalSubmitHandler.bind(this)}>
                                ارسال
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>






                <Modal
                    show={this.state.userModal}
                    onHide={this.userModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            اطلاعات کاربری
                        </div>
                        <div className="mt-3">
                            {
                                this.state.userError !== null ?
                                    (
                                        <div className="alert alert-danger mt-2">
                                            {this.state.userError}
                                        </div>
                                    )
                                    :
                                    (``)
                            }
                        </div>
                        <div  className="mt-3">
                            <div className="form-group form-group-custom-1">
                                <input
                                    type="text"
                                    className={["form-control form-control-custom-1" , errors['name'] ? 'is-invalid' : ''].join(' ')}
                                    name="name"
                                    onChange={this.handleChange.bind(this)}
                                    placeholder="نام و نام خانوادگی"
                                    value={this.state.fields.name}  />
                                <span className={["invalid-feedback" ,  errors['name'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['name'] }</span>
                                <img src={faceIcon} alt="name" className="item-icon" />
                            </div>


                            <div className="form-group form-group-custom-1">
                                <select
                                    name="gender"
                                    className={["form-control form-control-custom-1" , errors['gender'] ? 'is-invalid' : ''].join(' ')}
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.fields.gender}>
                                    <option value="male" >مرد</option>
                                    <option value="female">زن</option>
                                    <option value="other">سایر</option>
                                </select>
                                <span className={["invalid-feedback" ,  errors['gender'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['gender'] }</span>
                                <img src={userIcon} alt="gender" className="item-icon" />
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-3" onClick={this.userSubmitHandler.bind(this)}>
                                ثبت
                            </button>
                        </div>

                    </Modal.Body>
                </Modal>







                <Modal
                    show={this.state.walletModal}
                    onHide={this.walletModalHideHandler.bind(this)}
                    className="bottom-sheet modal-custom-2" centered>

                    <Modal.Body>
                        <div className="title">
                            شارژ اعتبار کیف پول
                        </div>
                        <div>
                            {
                                this.state.messageError !== null ?
                                    (
                                        <div className="alert alert-danger mt-2">
                                            {this.state.messageError}
                                        </div>
                                    )
                                    :
                                    (``)
                            }
                        </div>

                        <div className="mt-3">
                            <div className="swiper-container" id="price-slider" dir="rtl" >
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide w-auto"  >
                                        <div onClick={() => this.setState({fields:{
                                                price : 25000 ,
                                                name : localStorage.getItem("name") ,
                                                gender : localStorage.getItem("gender") ,
                                                body : "" ,
                                            }})}
                                             className={"card-custom-5 " +  (price === 25000 ?  "active " : "")}>
                                            25،000
                                        </div>
                                    </div>
                                    <div className="swiper-slide w-auto"  >
                                        <div onClick={() => this.setState({fields:{
                                                price : 50000 ,
                                                name : localStorage.getItem("name") ,
                                                gender : localStorage.getItem("gender") ,
                                                body : "" ,
                                            }})}  className={"card-custom-5 " +  (price === 50000 ?  "active " : "")}>
                                            50،000
                                        </div>
                                    </div>
                                    <div className="swiper-slide w-auto"  >
                                        <div onClick={() => this.setState({fields:{
                                                price : 100000 ,
                                                name : localStorage.getItem("name") ,
                                                gender : localStorage.getItem("gender") ,
                                                body : "" ,
                                            }})}  className={"card-custom-5 " + (price === 100000 ?  "active " : "")}>
                                            100،000
                                        </div>
                                    </div>
                                    <div className="swiper-slide w-auto"  >
                                        <div onClick={() => this.setState({fields:{
                                                price : 200000 ,
                                                name : localStorage.getItem("name") ,
                                                gender : localStorage.getItem("gender") ,
                                                body : "" ,
                                            }})}  className={"card-custom-5 " + (price === 200000 ?  "active " : "")}>
                                            200،000
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div  className="mt-3">
                            <div className="form-group form-group-custom-2">
                                <input
                                    type="number"
                                    className={["form-control form-control-custom-2" , errors['price'] ? 'is-invalid' : ''].join(' ')}
                                    name="price"
                                    onChange={this.handleChange.bind(this)}
                                    placeholder="مبلغ دلخواه"
                                    value={this.state.fields.price}  />
                                <span className={["invalid-feedback" ,  errors['price'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['price'] }</span>
                                <span className="item-icon">تومان</span>
                            </div>
                        </div>
                        <div className="mt-5">
                            <button className="btn btn-block btn-custom-2" onClick={this.walletModalSubmitHandler.bind(this)}>
                                پرداخت
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>



                <Footer page="profile"/>

            </div>
        )
    }
}

export default Profile;